export default function listen(transport, callback) {
    let isListening = true;
    transport.addEventListener('message', callback);
    return {
        start: ()=>{
            if (isListening) {
                return;
            }
            transport.addEventListener('message', callback);
        },
        stop: ()=>{
            transport.removeEventListener('message', callback);
            isListening = false;
        }
    };
}

//# sourceMappingURL=listen.js.map